module.exports = __webpack_public_path__ + "static/media/rukuliucheng61.e3bbab0f.png";